var _style, _rect, _g, _path, _path2, _circle, _circle2, _defs, _g2, _path3, _defs2, _g3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{opacity:0.12;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#7B83EB;}\n\t.st4{fill:#5059C9;}\n\t.st5{clip-path:url(#SVGID_2_);}\n\t.st6{opacity:0.3;}\n\t.st7{opacity:0.24;}\n\t.st8{clip-path:url(#SVGID_4_);}\n\t.st9{opacity:0.48;}\n\t.st10{fill:#4B53BC;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 512,
    height: 512
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Teams"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M483.1,224.1V328c0,39.4-32,71.5-71.5,71.5l0,0c-10.3,0-20.2-2.2-29.5-6.5c-18.4,42.8-60.3,70.7-106.9,70.9 c-65.3-0.7-117.5-54.4-116.8-119.5V224.3c-0.2-10.8,8.5-19.6,19.4-19.8h286c10.6,0,19.4,8.6,19.4,19.4l0,0L483.1,224.1 L483.1,224.1L483.1,224.1z M275.4,178.1c35.8,0.2,65-29,65.2-64.8c0.2-35.8-29-65-64.8-65.2c-35.8-0.2-65,29-65.2,64.8v0.2 c-0.4,35.8,28.4,65.3,64.3,65.7l0,0h0.5V178.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M483.1,224.1V328c0,39.4-32,71.5-71.5,71.5l0,0c-10.3,0-20.2-2.2-29.5-6.5c-18.4,42.8-60.3,70.7-106.9,70.9 c-65.3-0.7-117.5-54.4-116.8-119.5V224.3c-0.2-10.8,8.5-19.6,19.4-19.8h286c10.6,0,19.4,8.6,19.4,19.4l0,0L483.1,224.1 L483.1,224.1L483.1,224.1z M275.4,178.1c35.8,0.2,65-29,65.2-64.8c0.2-35.8-29-65-64.8-65.2c-35.8-0.2-65,29-65.2,64.8v0.2 c-0.4,35.8,28.4,65.3,64.3,65.7l0,0h0.5V178.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Body-2",
    className: "st4",
    d: "M350.4,204.7h113c10.6,0,19.4,8.6,19.4,19.3c0,0,0,0,0,0.2l0,0V328c0,39.4-32,71.5-71.5,71.5 l0,0c-39.4,0-71.5-32-71.5-71.5l0,0V214.8c0-5.6,4.5-10.1,10.1-10.1l0,0H350.4L350.4,204.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Head",
    className: "st4",
    cx: 411.6,
    cy: 133.2,
    r: 45.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Head-2",
    className: "st3",
    cx: 275.4,
    cy: 113.6,
    r: 65
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M350.4,204.7h113c10.6,0,19.4,8.6,19.4,19.3c0,0,0,0,0,0.2l0,0V328c0,39.4-32,71.5-71.5,71.5l0,0 c-39.4,0-71.5-32-71.5-71.5l0,0V214.8c0-5.6,4.5-10.1,10.1-10.1l0,0H350.4L350.4,204.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M372.7,204.7H178c-10.8,0-19.6,8.8-19.6,19.6l0,0v120.1c0.7,64.4,53.8,116.1,118.3,115.4 c63.4-0.7,114.7-52,115.4-115.4V224.5c0.2-10.6-8.1-19.6-18.9-19.8l0,0H372.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M372.7,204.7H178c-10.8,0-19.6,8.8-19.6,19.6l0,0v120.1c0.7,64.4,53.8,116.1,118.3,115.4 c63.4-0.7,114.7-52,115.4-115.4V224.5c0.2-10.6-8.1-19.6-18.9-19.8l0,0H372.7z"
  }))))))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M372.7,204.7H178c-10.8,0-19.6,8.8-19.6,19.6l0,0v120.1c0.7,64.4,53.8,116.1,118.3,115.4 c63.4-0.7,114.7-52,115.4-115.4V224.5c0.2-10.6-8.1-19.6-18.9-19.8l0,0H372.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M210.5,113.6c0-35.8,29.2-65,65-65s65,29.2,65,65s-29.2,65-65,65l0,0h-0.2 C239.5,178.6,210.5,149.6,210.5,113.6L210.5,113.6z M371.8,204.7H178c-10.8,0-19.6,8.8-19.6,19.6l0,0v120.1 c0.7,64.4,53.8,116.1,118.3,115.4c63.4-0.7,114.7-52,115.4-115.4V224.5c0.2-10.6-8.1-19.6-18.9-19.8l0,0H371.8L371.8,204.7 z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ambient"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.4,139.7h194.4c10.8,0,19.6,8.8,19.6,19.6v194.4c0,10.8-8.8,19.6-19.6,19.6H48.4 c-10.8,0-19.6-8.8-19.6-19.6V159.3C28.7,148.5,37.6,139.7,48.4,139.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.4,139.7h194.4c10.8,0,19.6,8.8,19.6,19.6v194.4c0,10.8-8.8,19.6-19.6,19.6H48.4 c-10.8,0-19.6-8.8-19.6-19.6V159.3C28.7,148.5,37.6,139.7,48.4,139.7z"
  })))))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M48.4,139.7h194.4c10.8,0,19.6,8.8,19.6,19.6v194.4c0,10.8-8.8,19.6-19.6,19.6H48.4 c-10.8,0-19.6-8.8-19.6-19.6V159.3C28.7,148.5,37.6,139.7,48.4,139.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M196.7,213.9h-38.9v106h-24.7v-106H94.4v-20.7h102.2L196.7,213.9L196.7,213.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftTeams);
export default __webpack_public_path__ + "static/media/microsoft-teams.f24fbe264cd34a9d69fa2630f1b4657d.svg";
export { ForwardRef as ReactComponent };